import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";


const firebaseConfig: any = {
   apiKey: "AIzaSyCmmBFJfmkV51RP7ZUU68QvxQDloaNLGVw",
    authDomain: "team-pulse-4c7c5.firebaseapp.com",
    projectId: "team-pulse-4c7c5",
    storageBucket: "team-pulse-4c7c5.firebasestorage.app",
    messagingSenderId: "50762971848",
    appId: "1:50762971848:web:c9b5afcd0d9798ea3fc3fd",
    measurementId: "G-YFR978QL6B",
};


const app = initializeApp(firebaseConfig);
console.log("Firebase initialized successfully");
const auth = getAuth(app);

export { auth, app };
